<template>
  <div class="report-view report-summary-information">
    <div class="report-head">
      <h5 class="text-center">Отчет биотехнических и охранных мероприятий за {{ year }} год
        <label v-if="oopt"><u>{{ oopt }}</u>
          <span class="sm-hint">наименование охотпользователя  (региональных управлений Главохоты)</span>
        </label>
      </h5>
    </div>
    <!-- report-body -->
    <div class="report-body">
      <div class="table-overflow">
        <table class="table-full">
          <thead>
          <tr>
            <td rowspan="4">Наименование охотхозяйства</td>
            <td v-for="(parentHeader, parentHeaderKey) in header" :colspan="2*parentHeader.colspan"
                v-bind:key="'headParent_'+parentHeaderKey">{{ parentHeader.transName }}
            </td>
          </tr>
          <tr>
            <template v-for="childrenHeader in header">
              <td v-for="childHeader in childrenHeader.children" :colspan="2*childHeader.colspan"
                  v-bind:key="'headChildren_'+childHeader.id">
                {{ childHeader.transName }}
              </td>
              <td v-for="event in childrenHeader.events" rowspan="2" colspan="2"
                  v-bind:key="'headEvent_'+event.event.id">
                {{ event.event.transName }}
              </td>
            </template>
          </tr>
          <tr>
            <template v-for="childrenHeader in header">
              <template v-for="childHeader in childrenHeader.children">
                <td v-for="childEvent in childHeader.events" colspan="2"
                    v-bind:key="'headChildEvent_'+childEvent.event.id">
                  {{ childEvent.event.transName }}
                </td>
              </template>
            </template>
          </tr>
          <tr>
            <template v-for="childrenHeader in header">
              <template v-for="childHeader in childrenHeader.children">
                <template v-for="childEvent in childHeader.events">
                  <td v-bind:key="'countChild_'+childEvent.event.id">Кол</td>
                  <td v-bind:key="'sumChild_'+childEvent.event.id">Сумма</td>
                </template>
              </template>
              <template v-for="event in childrenHeader.events">
                <td v-bind:key="'countEvent_'+event.event.id">Кол</td>
                <td v-bind:key="'sumEvent_'+event.event.id">Сумма</td>
              </template>
            </template>
          </tr>
          </thead>
          <tbody>
          <template v-if="reportData">
            <tr v-for="item in reportData" :key="item.ooptId">
              <td>{{ item.ooptName }}</td>
              <template v-for="childrenHeader in header">
                <template v-for="childHeader in childrenHeader.children">
                  <template v-for="childEvent in childHeader.events">
                    <td v-bind:key="'countChild_'+childHeader.id+'_'+childEvent.event.id">
                      {{ item.eventTypes[childHeader.id] ? item.eventTypes[childHeader.id][childEvent.event.id] ? item.eventTypes[childHeader.id][childEvent.event.id].factCount : '' : '' }}
                    </td>
                    <td v-bind:key="'sumChild_'+childHeader.id+'_'+childEvent.event.id">
                      {{ item.eventTypes[childHeader.id] ? item.eventTypes[childHeader.id][childEvent.event.id] ? item.eventTypes[childHeader.id][childEvent.event.id].factSum : '' : '' }}
                    </td>
                  </template>
                </template>
                <template v-for="event in childrenHeader.events">
                  <td v-bind:key="'countChildValue_'+event.event.id">
                    {{ item.eventTypes[childrenHeader.id] ? item.eventTypes[childrenHeader.id][event.event.id] ? item.eventTypes[childrenHeader.id][event.event.id].factCount : '' : '' }}
                  </td>
                  <td v-bind:key="'sumChildValue_'+event.event.id">
                    {{ item.eventTypes[childrenHeader.id] ? item.eventTypes[childrenHeader.id][event.event.id] ? item.eventTypes[childrenHeader.id][event.event.id].factSum : '' : '' }}
                  </td>
                </template>
              </template>
            </tr>
          </template>
          <template v-if="total">
            <tr>
              <td><b>Итого</b></td>
              <template v-for="childrenHeader in header">
                <template v-for="childHeader in childrenHeader.children">
                  <template v-for="childEvent in childHeader.events">
                    <td v-bind:key="'totalCountChild_'+childHeader.id+'_'+childEvent.event.id">
                      <b>{{ total[childHeader.id] ? total[childHeader.id][childEvent.event.id] ? total[childHeader.id][childEvent.event.id].factCount : '' : '' }}</b>
                    </td>
                    <td v-bind:key="'totalSumChild_'+childHeader.id+'_'+childEvent.event.id">
                      <b>{{ total[childHeader.id] ? total[childHeader.id][childEvent.event.id] ? total[childHeader.id][childEvent.event.id].factSum : '' : '' }}</b>
                    </td>
                  </template>
                </template>
                <template v-for="event in childrenHeader.events">
                  <td v-bind:key="'totalCountChildValue_'+event.event.id">
                    <b>{{ total[childrenHeader.id] ? total[childrenHeader.id][event.event.id] ? total[childrenHeader.id][event.event.id].factCount : '' : '' }}</b>
                  </td>
                  <td v-bind:key="'totalSumChildValue_'+event.event.id">
                    <b>{{ total[childrenHeader.id] ? total[childrenHeader.id][event.event.id] ? total[childrenHeader.id][event.event.id].factSum : '' : '' }}</b>
                  </td>
                </template>
              </template>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    reportData: Array,
    header: Array,
    total: Array,
    year: String,
    oopt: String
  },
  data: () => ({
    tdCount: 0
  })
}
</script>

<style scoped>

</style>
